import {
    addStocksToWatchList,
    removeStocksFromWatchList,
    updateFinCodesWatchListMap
} from "@/store/features/watchListSlice";
import React, { Fragment, memo, useEffect, useState } from "react";
import { FaBookmark, FaRegBookmark } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
    DropdownMenuCheckboxItem,
    DropdownMenuLabel
} from "@/components/ui/dropdown-menu";
import CreateNewWatchList from "./WatchListSideBar/CreateNewWatchList";
import { cn } from "@/lib/utils";
import Hint from "../Hint";
import { Mixpanel } from "@/elements/Mixpanel";
import { getInstrument } from "@/lib/tradeCards";
import { RECENT_SEARCHES_KEY } from "@/lib/watchList";

function WatchListButton({
    watchListIds,
    finCode,
    exchange: exch,
    className = "",
    size = "16px",
    setParentOpen = () => {},
    pageName,
    symbol,
    isInfoButton = false,
    disabled
}) {
    // const { userData } = useSelector((state) => state.userDetails);
    // const userId = userData?.id;
    const [isOpen, setOpen] = useState(false);
    const { watchLists, finCodesWatchListMap } = useSelector((state) => state.watchList);
    const dispatch = useDispatch();
    const exchange = exch == "NFO" ? "NSE" : exch == "BFO" ? "BSE" : exch;

    useEffect(() => {
        dispatch(updateFinCodesWatchListMap({ [`${finCode}-${exchange}`]: watchListIds ?? [] }));

        // const storedRecentSearches = JSON.parse(localStorage.getItem(`${RECENT_SEARCHES_KEY}-${userId}`)) || [];
        // localStorage.setItem(`${RECENT_SEARCHES_KEY}-${userId}`, JSON.stringify(storedRecentSearches));
    }, []);

    const active = finCodesWatchListMap?.[`${finCode}-${exchange}`]?.length > 0;

    useEffect(() => {
        if (isOpen) {
            Mixpanel.track("cta_clicked", {
                page: pageName,
                fincode: finCode,
                exchange: exchange,
                symbol: symbol,
                cta_text: "awl_clicked",
                instrument_name: getInstrument(symbol),
                is_watchlisted: watchListIds ? true : false
            });
        }
    }, [isOpen]);

    return (
        <DropdownMenu
            onOpenChange={(e) => {
                setOpen(e);
                setParentOpen(e);
            }}
            open={disabled ? false : isOpen}
        >
            <Hint label="Watchlist" side={"top"} align="end" alignOffset={-10}>
                <DropdownMenuTrigger asChild>
                    {isInfoButton ? (
                        <div className=" hover:bg-[#F8FAFF] cursor-pointer flex items-center gap-4 self-stretch bg-[#FFF] p-4">
                            <div
                                className={cn("cursor-pointer bg-white hover:bg-[#FFFFFFBF]", className)}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setParentOpen(true);
                                    setOpen(true);
                                }}
                            >
                                {active ? (
                                    <FaBookmark size={size} color="#00439D" id="remove-from-watchlist" />
                                ) : (
                                    <FaRegBookmark size={size} color="#414141" id="add-to-watchlist" />
                                )}
                            </div>
                            <p className="text-[#202020] text-sm font-semibold hover:font-bold leading-6">
                                Add to watchlist
                            </p>
                        </div>
                    ) : (
                        <div
                            className={cn("cursor-pointer bg-white", className)}
                            onClick={(e) => {
                                e.stopPropagation();
                                setParentOpen(true);
                                setOpen(true);
                            }}
                        >
                            {active ? (
                                <FaBookmark size={size} color="#00439D" id="remove-from-watchlist" />
                            ) : (
                                <FaRegBookmark size={size} color="#414141" id="add-to-watchlist" />
                            )}
                        </div>
                    )}
                </DropdownMenuTrigger>
            </Hint>

            <DropdownMenuContent
                className="w-64 max-h-[300px] overflow-auto rounded-2xl p-0"
                onClick={(e) => {
                    e?.stopPropagation();
                }}
            >
                <DropdownMenuLabel className="bg-[#ECF6FE] text-primary text-sm font-semibold py-2 px-3">
                    {watchLists?.length > 0 ? "My Watchlists" : "No watchlist available"}
                </DropdownMenuLabel>
                {watchLists?.length > 0 ? (
                    <>
                        {watchLists?.map((item, index) => (
                            <Fragment key={index}>
                                {index !== 0 && <DropdownMenuSeparator />}
                                <DropdownMenuCheckboxItem
                                    className={cn("mx-2 px-3 py-2 rounded-lg text-sm font-semibold cursor-pointer", {
                                        "mt-1": index === 0,
                                        "mb-1": index === watchLists?.length - 1
                                    })}
                                    value={item?.name}
                                    checked={
                                        finCodesWatchListMap?.[`${finCode}-${exchange}`] &&
                                        finCodesWatchListMap?.[`${finCode}-${exchange}`]?.includes(item.id)
                                    }
                                    onCheckedChange={(active) => {
                                        if (!active) {
                                            dispatch(
                                                removeStocksFromWatchList({ activeId: item?.id, finCode, exchange })
                                            );
                                        } else {
                                            dispatch(addStocksToWatchList({ activeId: item?.id, finCode, exchange }));
                                        }
                                    }}
                                >
                                    <span id={item?.name}>{item.name}</span>
                                </DropdownMenuCheckboxItem>
                            </Fragment>
                        ))}
                    </>
                ) : (
                    <CreateNewWatchList preFillName={`My watchlist 1`} type="CREATE" className="w-full px-3 py-2">
                        <div className="w-full inline-flex items-center justify-center whitespace-nowrap ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-950 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 dark:ring-offset-slate-950 dark:focus-visible:ring-slate-300 text-slate-50 hover:bg-primary/90 dark:bg-slate-50 dark:text-primary dark:hover:bg-slate-50/90 h-10 px-4 py-2 text-sm rounded-lg font-bold bg-primary/80">
                            Create watchlist
                        </div>
                    </CreateNewWatchList>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
export default memo(WatchListButton);
